import React from "react";
import { authPaymentTypes } from "../../../parent/data/auth-payment-types";
import Show from "../../../../../utils/show.component";

export const PrincipalOnlyPopupButton = ({
  PaymentAllowed,
  CurrentBalance,
  PayoffPending,
  AmountPastDue,
  IsCreditOrExternalAccount,
  AchIsAllowed,
  selectPaymentType,
  lastFour,
}) => {
  const shouldShowPrincipalOnly = () => {
    const show =
      PaymentAllowed &&
      CurrentBalance &&
      !PayoffPending &&
      !AmountPastDue &&
      !IsCreditOrExternalAccount
        ? true
        : false;

    return show;
  };

  return (
    <Show condition={shouldShowPrincipalOnly()}>
      <li>
        <button
          className="f12 mt-0 auth-card-popup-button"
          onClick={() => {
            selectPaymentType(authPaymentTypes.valid.Standard, AchIsAllowed, true);
          }}
          data-e2e-id={"principalOnlyPaymentButton-" + lastFour}
        >
          Make Principal Only Payment
        </button>
      </li>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/card-children/popup-menu-buttons/principal-only-popup-button.component.js